import "./styles.less";

import { Button, Checkbox, Col, Row, Space, Typography } from "antd";
import React, { useEffect, useState } from "react";

import { PropComponentMode } from "../../PropertyInterfaces";
import { PropertyCard } from "../../PropertyCard/web";
import { usePropertySimilars } from "shared-components/ViewFragments/PropertyDetails/PropertySimilars/hook";
import { useTheme } from "../../../../Styles/ThemeHook";
import { Carousel } from "src/Components/Carousel/web";

const { Text, Title } = Typography;

type SimilarsLeadProps = {
	id: string;
	onSend: (propertyIds) => void;
	onCancel: () => void;
	mode: PropComponentMode;
};

export default function SimilarsLead({ id, mode, onSend, onCancel }: SimilarsLeadProps) {
	const [propertyIds, setPropertyIds] = useState<Set<string>>(new Set());
	const { theme } = useTheme();

	const { data: properties } = usePropertySimilars({
		property_id: id,
		mode,
		results_per_page: 6,
	});

	useEffect(() => {
		if (properties && properties?.length > 0) {
			setPropertyIds(new Set(properties?.map(({ id }) => id) ?? []));
		}
	}, [properties]);

	const handleChange = e => {
		const id = e.target.value;
		const copy = new Set(propertyIds);
		if (copy.has(id)) copy.delete(id);
		else copy.add(id);
		setPropertyIds(copy);
	};
	const onClickSend = () => onSend(propertyIds);
	const onClickCancel = () => onCancel();

	if (!properties?.length) return null;

	const CarouselItem = ({ data }) => (
		<div className="card-container" key={data.property_id}>
			<Checkbox
				className="similar-lead-checkbox"
				value={data.id}
				checked={propertyIds.has(data.id)}
				onChange={handleChange}
			/>
			<PropertyCard
				onModalSimilarsCancelClick={onClickCancel}
				property={data}
				id={data.id}
				hideActions
				hideTags
				staticGallery
			/>
		</div>
	)

	return (
		<div className="similar-lead">
			<Row gutter={[0, theme.spacing.xlSpacing]} className={"similar-lead-row"}>
				<Col span={24}>
					<Row justify={"center"} style={{ textAlign: "center" }}>
						<Col span={24}>
							<Text>{"¡Tu consulta fue enviada con éxito!"}</Text>
						</Col>
						<Col span={24}>
							<Title level={4} className="similar-lead-title">Te recomendamos estas propiedades similares</Title>
						</Col>
						<Col span={24}>
							<Text>Envía una consulta automática y no pierdes ninguna oportunidad</Text>
						</Col>
					</Row>
				</Col>
				<Col span={24}>
					<div className="similar-lead-property-row">
						<Carousel data={properties} ItemComponent={CarouselItem} />
					</div>
				</Col>
				<Col span={24} className="similar-lead-btn-consultar">
					<Button onClick={onClickSend} type={"primary"}>
						Consultar
					</Button>
				</Col>
				<Col span={24} className="similar-lead-btn-cancel">
					<Button type={"text"} onClick={onClickCancel}>
						No, gracias
					</Button>
				</Col>
			</Row>
		</div>
	);
}
